if (!customElements.get('per-day-price')) {
  class PerDayPrice extends HTMLElement {

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.variantData = null;
      this.observer = null;

      console.log('[PerDayPrice] connectedCallback, sectionId:', this.sectionId);

      this.loadVariantData();
      this.inject();
      this.watchForReRenders();
      this.watchForVariantChanges();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    loadVariantData() {
      var el = document.getElementById('PerDayData-' + this.sectionId);
      if (!el) {
        console.warn('[PerDayPrice] JSON nicht gefunden: PerDayData-' + this.sectionId);
        return;
      }
      try {
        this.variantData = JSON.parse(el.textContent);
        console.log('[PerDayPrice] Varianten geladen:', Object.keys(this.variantData).length);
      } catch (e) {
        console.error('[PerDayPrice] JSON Parse Fehler:', e);
      }
    }

    /**
     * Gibt { price, available } zurück oder null
     */
    getVariantInfo() {
      var variantId = new URLSearchParams(window.location.search).get('variant');

      /* Variante aus URL */
      if (variantId && this.variantData && this.variantData[variantId]) {
        var d = this.variantData[variantId];
        if (!d.available) return { price: null, available: false };
        if (d.portionen > 0) {
          return {
            price: this.formatMoney(Math.ceil(d.price / d.portionen)),
            available: true
          };
        }
        return null;
      }

      /* Fallback: Liquid-gerenderter Preis */
      var source = this.querySelector('[data-per-day-price]');
      if (source && source.textContent.trim()) {
        return { price: source.textContent.trim(), available: true };
      }

      /* Fallback: Erste verfügbare Variante mit Portionen */
      if (this.variantData) {
        var keys = Object.keys(this.variantData);
        for (var i = 0; i < keys.length; i++) {
          var d = this.variantData[keys[i]];
          if (d.available && d.portionen > 0) {
            return {
              price: this.formatMoney(Math.ceil(d.price / d.portionen)),
              available: true
            };
          }
        }
      }

      return null;
    }

    inject() {
      var priceContainer = document.getElementById('price-' + this.sectionId);
      if (!priceContainer) {
        console.warn('[PerDayPrice] Preis-Container nicht gefunden: price-' + this.sectionId);
        return;
      }

      /* Alte injizierte Elemente entfernen */
      var old = priceContainer.querySelector('.per-day-line--injected');
      if (old) old.remove();

      /* Preis + Verfügbarkeit prüfen */
      var info = this.getVariantInfo();
      if (!info || !info.available || !info.price) {
        console.log('[PerDayPrice] Ausgeblendet (ausverkauft oder keine Portionen)');
        /* Flex-Styling trotzdem beibehalten falls andere Elemente drin sind */
        return;
      }

      console.log('[PerDayPrice] Injiziere:', info.price);

      /* Preis-Container als Flex-Row */
      priceContainer.style.display = 'flex';
      priceContainer.style.alignItems = 'center';
      priceContainer.style.flexWrap = 'wrap';
      priceContainer.style.gap = '12px';

      /* Element erstellen */
      var el = document.createElement('span');
      el.className = 'per-day-line per-day-line--injected';
      el.innerHTML =
        '<span class="per-day-line__prefix">nur</span> ' +
        '<span class="per-day-line__price">' + info.price + '</span> ' +
        '<span class="per-day-line__suffix">pro Portion</span>';

      priceContainer.appendChild(el);

      /* Fallback-Element verstecken */
      var fallback = this.querySelector('.per-day-line--fallback');
      if (fallback) fallback.style.display = 'none';
    }

    watchForReRenders() {
      var productInfo = document.getElementById('ProductInfo-' + this.sectionId);
      if (!productInfo) {
        console.warn('[PerDayPrice] ProductInfo nicht gefunden');
        return;
      }

      var self = this;
      this.observer = new MutationObserver(function () {
        var pc = document.getElementById('price-' + self.sectionId);
        if (pc && !pc.querySelector('.per-day-line--injected')) {
          console.log('[PerDayPrice] Re-Render erkannt, injiziere neu');
          requestAnimationFrame(function () { self.inject(); });
        }
      });

      this.observer.observe(productInfo, { childList: true, subtree: true });
      console.log('[PerDayPrice] MutationObserver aktiv');
    }

    watchForVariantChanges() {
      var self = this;
      var handler = function () {
        console.log('[PerDayPrice] URL-Änderung erkannt');
        requestAnimationFrame(function () { self.inject(); });
      };

      window.addEventListener('popstate', handler);

      if (!window.__perDayPatched) {
        ['pushState', 'replaceState'].forEach(function (method) {
          var orig = history[method];
          history[method] = function () {
            var result = orig.apply(this, arguments);
            window.dispatchEvent(new Event('perday:urlchange'));
            return result;
          };
        });
        window.__perDayPatched = true;
      }
      window.addEventListener('perday:urlchange', handler);
    }

    formatMoney(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents);
      }
      return '\u20AC' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  customElements.define('per-day-price', PerDayPrice);
  console.log('[PerDayPrice] Custom Element registriert');
}
